// Which saved API connections the Connectors page shows under which customer system.
// Pure functions (no React), so tests run them under node.

// A system's backend product ids: the platform-config family whose `product_ids` holds
// the system's stored product_id. Matched by membership, not by the family's own `id`,
// which is just whichever schema file sorts first for that label. [] when the family is
// unknown (platform-config still loading, or an unrecognised product id): never "every
// product this vendor has", which put one connection under several systems.
export function backendProductsFor(system, platformConfig) {
  const vendorId = String(system?.vendor_id || '').toLowerCase()
  const v = platformConfig?.vendors?.find(x => x.id === vendorId)
  const pid = String(system?.product_id || '').toLowerCase()
  const p = v?.products?.find(x => (x.product_ids || []).includes(pid) || x.id === pid)
  return p?.product_ids?.length ? p.product_ids : []
}

// A connection belongs to a system when the vendors agree and its product id is one of
// the system's backend products.
function belongsTo(conn, system, products) {
  return String(conn?.vendor_id || '').toLowerCase() === String(system?.vendor_id || '').toLowerCase()
    && products.has(String(conn?.product_id || '').toLowerCase())
}

// { bySystem: [{ system, backendProducts, connections }], unplaced: [connection] }.
// Every connection is in exactly one of the two: one that matches no system (saved from
// "+ Add Connection" for a product the customer's profile does not list, or whose
// product id the registry could not name) is `unplaced`, and the page lists it on its
// own instead of counting it and showing it nowhere.
export function groupConnections(systems, connections, platformConfig) {
  const placed = new Set()
  const bySystem = (systems || []).map(system => {
    const backendProducts = backendProductsFor(system, platformConfig)
    const products = new Set(backendProducts.map(p => String(p).toLowerCase()))
    const mine = (connections || []).filter(c => belongsTo(c, system, products))
    mine.forEach(c => placed.add(c))
    return { system, backendProducts, connections: mine }
  })
  const unplaced = (connections || []).filter(c => !placed.has(c))
  return { bySystem, unplaced }
}

// Why a save-connection response is a failure, or null when it saved. The route answers
// 200 with {success: false, error} when the connection test or the save fails, so a
// resolved request alone does not mean anything was saved.
export function saveFailure(resp) {
  if (resp && resp.success === true) return null
  if (resp && resp.error) return String(resp.error)
  return 'The server did not confirm the connection was saved'
}
